// Module
var code = "<div id=\"V-A39816AC-EB57-484B-B189-4C57CCC71DFC\"> <div data-b-component=\"scroll\" data-b-comp-vertical=\"true\"> <ul class=\"V-A39816AC-EB57-484B-B189-4C57CCC71DFC\" data-b-itemsSource=\"{Binding internalItems}\"> </ul> </div> </div> ";
// Exports
export default code;